import logo from './logo.svg';
import './App.css';
import Header from './Component/Header'
import './css/set.css'
import Main from './Component/Main'
import Footer from './Component/footer'
function App() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
